import { MicItem } from '../../../../../utils/types/mics';
import { TableData } from '../../../types';

export const transformData = (data?: MicItem[] | null) => {
  if (!data || data.length === 0) {
    return [];
  }

  const transformedData: TableData[] = data.map((item) => {
    return {
      key: item?.id,
      description: item?.merchandise_id?.description,
      quantity: item?.quantity,
      UM: item?.unit,
    };
  });

  return transformedData;
};
